<template>
    <div class="vrm-modal vrm-modal--alert vrm-modal--alert--warning mfp-with-anim">
        <form class="vrm-modal__content" @submit.prevent="onSubmit" @reset.prevent="onReset">
            <div class="vrm-modal__title">
                <div class="vrm-modal__title-icon sg-vrm-icon_012_alarm-32px" />
            </div>
            <p>{{ messageText }}</p>
            <div class="vrm-modal__main-button">
                <button type="submit" class="sg-element sg-btn sg-blue">
                    {{ $t('common.confirm', { i18nFallback: 'Confirm' }) }}
                </button>

                <button v-focus type="reset" class="sg-element sg-btn sg-site">
                    {{ $t('common.cancel', { i18nFallback: 'Cancel' }) }}
                </button>
            </div>
        </form>
        <modal-close-handle />
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: { ModalCloseHandle },
})
@AngularLocaleBundle('common')
export default class ConfirmActionModal extends Vue {
    @Prop()
    message;
    @Prop()
    onConfirm;

    get messageText() {
        return (
            this.message ||
            this.$t('common.confirm_action_prompt', {
                i18nFallback: 'Are you sure you want to perform this action?',
            })
        );
    }

    onSubmit() {
        this.onConfirm();
        this.$emit('close', true);
    }

    onReset() {
        this.$emit('close', false);
    }
}
</script>
